import { PREMIUM_FEATURES } from "@common/flatRateBilling";
import { useAllowFeature } from "./useAllowFeature";

export function usePlaidStatementsQualified(): boolean {
    const { hasAccess } = useAllowFeature(PREMIUM_FEATURES.PLAID_STATEMENTS, {
        shouldSkipSupportBypass: true,
    });
    return hasAccess;
}
